(function () {
  function receiptDocument(receiptHtml) {
    var styles = [
      'body{font-family:-apple-system,BlinkMacSystemFont,"Helvetica Neue",Arial,sans-serif;color:#111827;margin:0;padding:32px;background:#fff;}',
      '.receipt{max-width:760px;margin:0 auto;background:#fff;padding:36px;border:1px solid #e5e7eb;}',
      '.receipt__header{display:flex;justify-content:space-between;gap:24px;border-bottom:2px solid #111827;padding-bottom:18px;}',
      '.receipt__eyebrow{font-size:11px;letter-spacing:.12em;color:#6b7280;margin:0 0 6px;}',
      'h1{font-size:30px;margin:0;}.receipt__meta{font-size:13px;line-height:1.8;text-align:right;color:#374151;}',
      '.receipt__customer{margin:28px 0 18px;font-size:18px;border-bottom:1px solid #111827;padding-bottom:8px;}',
      '.receipt__amount{display:flex;align-items:baseline;gap:16px;margin:22px 0;padding:18px;background:#f3f4f6;}',
      '.receipt__amount span{font-size:14px;color:#4b5563}.receipt__amount strong{font-size:28px}.receipt__amount small{color:#6b7280}',
      '.receipt__note{font-size:13px;color:#374151}.receipt__table{width:100%;border-collapse:collapse;margin-top:24px;font-size:13px;}',
      '.receipt__table th,.receipt__table td{border-bottom:1px solid #e5e7eb;padding:10px;text-align:left}',
      '.receipt__table th:nth-child(2),.receipt__table td:nth-child(2){text-align:center;width:70px}',
      '.receipt__table th:nth-child(3),.receipt__table td:nth-child(3){text-align:right;width:130px}',
      '.receipt__summary{margin:24px 0 0 auto;width:min(340px,100%);font-size:14px}',
      '.receipt__summary div{display:flex;justify-content:space-between;padding:7px 0;border-bottom:1px solid #e5e7eb}',
      '.receipt__summary-total{font-weight:700;font-size:17px}',
      '.receipt__footer{margin-top:34px;text-align:right;font-size:13px;color:#374151;display:grid;gap:4px}',
      '@media print{body{padding:0}.receipt{border:0;padding:20px}.no-print{display:none}}'
    ].join('');

    return '<!doctype html><html lang="ja"><head><meta charset="utf-8"><title>領収書</title><style>' + styles + '</style></head><body>' + receiptHtml + '</body></html>';
  }

  function printReceipt(receiptHtml) {
    var oldFrame = document.getElementById('salowin-receipt-print-frame');
    if (oldFrame) oldFrame.remove();

    var frame = document.createElement('iframe');
    frame.id = 'salowin-receipt-print-frame';
    frame.setAttribute('aria-hidden', 'true');
    frame.style.position = 'fixed';
    frame.style.right = '0';
    frame.style.bottom = '0';
    frame.style.width = '0';
    frame.style.height = '0';
    frame.style.border = '0';
    frame.style.opacity = '0';
    document.body.appendChild(frame);

    var doc = frame.contentWindow.document;
    doc.open();
    doc.write(receiptDocument(receiptHtml));
    doc.close();

    setTimeout(function () {
      try {
        frame.contentWindow.focus();
        frame.contentWindow.print();
      } catch (e) {
        alert('領収書PDFの表示に失敗しました。ページを再読み込みして再度お試しください。');
      }
    }, 150);
  }

  function addToCart(button) {
    var variantId = button.getAttribute('data-variant-id');
    var qty = parseInt(button.getAttribute('data-quantity') || '1', 10);

    if (!variantId) return;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: qty }]
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Network response was not ok');
        return res.json();
      })
      .then(function () {
        alert('カートに追加しました。');
      })
      .catch(function () {
        alert('カートに追加できませんでした。時間をおいて再度お試しください。');
      });
  }

  document.addEventListener('click', function (event) {
    var receiptButton = event.target.closest('[data-salowin-receipt-open]');
    if (receiptButton) {
      var receiptId = receiptButton.getAttribute('data-salowin-receipt-open');
      var template = document.getElementById('salowin-receipt-' + receiptId);
      if (!template) return;
      printReceipt(template.innerHTML);
      return;
    }

    var reorderButton = event.target.closest('.js-order-reorder');
    if (reorderButton) {
      addToCart(reorderButton);
    }
  });

  window.SalowinReceipt = {
    buildDocument: receiptDocument,
    print: printReceipt
  };
})();
